module.exports = ".range-list li.inactive,.range-list li.inactive:hover{cursor:text;background:#ccc}"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/period-selector/period-selector.component.scss
// module id = 514
// module chunks = 0